/**
 * Utility function to get numeric value with fallback
 * @param value - The value to check (can be number, string, or undefined)
 * @param fallback - The fallback value to use if value is not a number
 * @returns The numeric value or fallback
 */
export const normalizeCssValue = (value: number | string | undefined, fallback: number): number => {
    return typeof value === "number" ? value : fallback;
};
